module.exports = __webpack_public_path__ + "static/5_Widget-66841ac5eb866e5dc9c8704e918903d8.png";